// Breach Step 2: Classification
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../../components/ui/card';
import { CheckCircle2 } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import { BREACH_TYPES } from '../constants';
import { TagInput } from '../../../../components/workflow';

export default function Step2Classification({ formData, updateField }) {
  return (
    <div className="space-y-6">
      <div><h2 className="text-2xl font-bold">Classification</h2><p className="text-muted-foreground mt-1">Classify the type, origin, and systems affected.</p></div>
      <Card>
        <CardHeader className="pb-3"><CardTitle className="text-base">Type of Breach</CardTitle><CardDescription>Select all that apply (CIA Triad)</CardDescription></CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            {BREACH_TYPES.map(type => {
              const sel = formData.breach_types.includes(type.id); const Icon = type.icon;
              return (
                <button key={type.id} type="button" data-testid={`breach-type-${type.id}`}
                  onClick={() => updateField('breach_types', sel ? formData.breach_types.filter(t => t !== type.id) : [...formData.breach_types, type.id])}
                  className={cn("p-4 border rounded-xl text-left transition-all relative", sel ? "border-primary bg-primary/5 ring-1 ring-primary" : "border-border hover:border-primary/50")}>
                  {sel && <CheckCircle2 className="absolute top-2 right-2 h-5 w-5 text-primary" />}
                  <Icon className="h-6 w-6 mb-2 text-primary" /><div className="font-medium text-sm">{type.label}</div>
                  <div className="text-xs text-muted-foreground mt-1">{type.subtitle}</div>
                </button>
              );
            })}
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="pb-3"><CardTitle className="text-base">Systems Affected</CardTitle><CardDescription>Type and press Enter to add</CardDescription></CardHeader>
        <CardContent>
          <TagInput tags={formData.systems_affected} onChange={t => updateField('systems_affected', t)} placeholder="e.g., Email Server, CRM System..." />
        </CardContent>
      </Card>
    </div>
  );
}
